import {ref} from 'vue';
import {useAuthStore} from '@/stores/auth.store';

const favoritos = ref<string[]>([]);
const modulosAbertos = ref<string[]>([]);
let publicIdCarregado: string | null = null;

function lerLista(chave: string): string[] {
    try {
        const bruto = localStorage.getItem(chave);
        return bruto ? JSON.parse(bruto) : [];
    } catch (e) {
        return [];
    }
}

function garantirCarregado() {
    const publicId = useAuthStore().userStore.publicId;

    if (publicId === publicIdCarregado) {
        return publicId;
    }

    publicIdCarregado = publicId;
    favoritos.value = lerLista(`menuFavoritos-${publicId}`);
    modulosAbertos.value = lerLista(`menuModulosAbertos-${publicId}`);

    return publicId;
}

export function useMenuPreferencias() {
    const publicId = garantirCarregado();

    const ehFavorito = (id: string) => favoritos.value.includes(id);

    const alternarFavorito = (id: string) => {
        favoritos.value = ehFavorito(id) ? favoritos.value.filter((f) => f !== id) : [...favoritos.value, id];
        localStorage.setItem(`menuFavoritos-${publicId}`, JSON.stringify(favoritos.value));
    };

    const estaAberto = (id: string) => modulosAbertos.value.includes(id);

    const alternarModulo = (id: string) => {
        modulosAbertos.value = estaAberto(id) ? modulosAbertos.value.filter((m) => m !== id) : [...modulosAbertos.value, id];
        localStorage.setItem(`menuModulosAbertos-${publicId}`, JSON.stringify(modulosAbertos.value));
    };

    const abrirModulo = (id: string) => {
        if (!estaAberto(id)) {
            alternarModulo(id);
        }
    };

    return {
        favoritos,
        modulosAbertos,
        ehFavorito,
        alternarFavorito,
        estaAberto,
        alternarModulo,
        abrirModulo
    };
}
